import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import { Changepassurl, Fetchwalleturl } from "./../Utils/urls";
import styles from "./../Hostels/houses.module.css";
import { FaDollarSign } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { getsessionuser, setsessionuser } from './../Utils/sessions';
import Universalheader from "../Headers/universalheader";
import { Alert, Container, Modal, Snackbar } from "@mui/material";
import SignIn from "../Common/login";
import { ChevronRight, CurrencyExchange, MonetizationOnOutlined, MoveDown, Receipt, ReceiptOutlined } from "@mui/icons-material";
import Fundwallet from "./fundwallet";
import Transactions from "./transactions";
import Standingorder from "./standingorder";
import { formatprice } from "../Utils/functions";
import Loadingspinner from "../Components/loading";
import Withdrawcash from "./withdrawcash";



let color = "white";
let type = "spokes";


const Mainwallet = ({ onrefresh }) => {

    const navigate = useNavigate();


    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser);

    //modals
    const [showlogin, setshowlogin] = useState(false);
    const [showfund, setshowfund] = useState(false);
    const [showwithdrawal, setshowwithdrawal] = useState(false);
    const [showtransactions, setshowtransactions] = useState(false);
    const [showstandingorder, setshowstandingorder] = useState(false);

    const [wallet, setwallet] = useState('');
    const [standingorder, setstandingorder] = useState('');


    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');

    const [redeemable, setredeemable] = useState('');

    useEffect(() => {
        if (!user) {
            setshowlogin(true)
        } else {
            fetchwalletbalance()
        }
    }, []);

    const fetchwalletbalance = (id) => {
        setloading(true)
        axios.post(Fetchwalleturl, {
            id: id ? id : user?.id,
        }).then(function (response) {
            setloading(false)
            if (!response.data.error) {
                user.wallet = response.data.wallet
                setsessionuser(user)
                setwallet(response.data.wallet)
                setstandingorder(response.data?.standingorder)
                setredeemable(response.data?.wallet - response.data?.standingorder?.amount)
                //console.log(response.data)
            } else {
                seterror(response.data.message);
            }
            // 
        }).catch(function (error) {
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }





    const onsuccesslogin = () => {
        setshowlogin(false)
        onrefresh()
        const userobject = sessionStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject)
            if (object) {
                setuser(object)
                fetchwalletbalance(object.id)
            }
        }
    }


    //fund account functions
    const onsuccessfund = () => {//on successfund
        setshowfund(false)
        setshowwithdrawal(false)
        setshowstandingorder(false)
        fetchwalletbalance()
        onrefresh()
    }
    const onfailfund = () => {//on fail fund

    }
    const oncancelfund = () => {// in cancel fund modal
        setshowfund(false)
        setshowwithdrawal(false)
        setshowtransactions(false)
        setshowstandingorder(false)
    }


    //open standing
    const openstanding = () => {
        if (standingorder) {
            seterror("You can only have one standing order")
        } else {
            if (redeemable < 1) {
                seterror("Fund your wallet first")
            } else {
                setshowstandingorder(true)
            }
        }
    }


    return (
        <div className={styles.container}>
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                {loading && <Loadingspinner />}
                <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                    <Alert severity="error">{error}</Alert>
                </Snackbar>
                <Universalheader refresh={showlogin} />
                <Modal
                    open={showlogin}
                    onClose={() => {
                        setshowlogin(false)
                        navigate("/nav/home")
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <SignIn onsuccesslogin={onsuccesslogin} />
                </Modal>
                <Modal
                    open={showwithdrawal}
                    onClose={() => setshowwithdrawal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Withdrawcash onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} />
                </Modal>
                <Modal
                    open={showfund}
                    onClose={() => setshowfund(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Fundwallet onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} />
                </Modal>
                <Modal
                    open={showtransactions}
                    onClose={() => setshowtransactions(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Transactions wallet={wallet} oncancelfund={oncancelfund} />
                </Modal>
                <Modal
                    open={showstandingorder}
                    onClose={() => setshowstandingorder(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Standingorder onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} wallet={wallet} />
                </Modal>
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>

                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>back  /</a>

                    <Link to="">
                        <a>{user?.username}  /</a>
                    </Link>

                </div>
                <div>
                    <div className={"wrapwalletdiv"}>
                        <div className="mywallettext">My Wallet</div>
                        <text style={{ color: "blue", fontSize: 12, cursor: "pointer" }} onClick={() => fetchwalletbalance()}>refresh</text>
                        <br />
                        <div className="wraptopwallet">
                            <div className="containerwith" >
                                <div className="wrapbalance">
                                    <div className="balancetext">
                                        Balance
                                    </div>
                                    <div className="balancenumber">
                                        {formatprice(wallet)} Ksh
                                    </div>
                                </div>
                            </div>
                            {standingorder &&
                                <div className="containerwith" >
                                    <div className="wrapbalance">
                                        <div className="standingordertext">
                                            Standing order
                                        </div>
                                        <div className="standingordernumber">
                                            {formatprice(standingorder.amount)} Ksh
                                            <text style={{ fontSize: 15 }}>/per {standingorder.interval} days</text>
                                        </div>
                                    </div>
                                </div>}
                        </div>

                        <br /><br />
                        <div className="walletbuttons" onClick={() => openstanding()}>
                            <div className="walletbuttonsleft">
                                <div className="walleticondiv">
                                    <CurrencyExchange />
                                </div>
                                <div>Standing Orders</div>
                            </div>
                            <ChevronRight />
                        </div>
                        <div className="walletbuttons" onClick={() => setshowtransactions(true)}>
                            <div className="walletbuttonsleft">
                                <div className="walleticondiv">
                                    <ReceiptOutlined />
                                </div>
                                <div>Transaction records</div>
                            </div>
                            <ChevronRight />
                        </div>
                        <div className="walletbuttons" onClick={() => setshowfund(true)}>
                            <div className="walletbuttonsleft">
                                <div className="walleticondiv">
                                    <MoveDown />
                                </div>
                                <div>Fund my account</div>
                            </div>
                            <ChevronRight />
                        </div>
                        <div className="walletbuttons" onClick={() => setshowwithdrawal(true)}>
                            <div className="walletbuttonsleft">
                                <div className="walleticondiv">
                                    <MonetizationOnOutlined />
                                </div>
                                <div>Withdraw Cash</div>
                            </div>
                            <ChevronRight />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mainwallet;